<template>
    <div v-if="!requisicaoFinalizada" class="loading-overlay">
        <div class="spinner"></div>
    </div>
    <div v-if="requisicaoFinalizada">
        <header class="site-header">
            <div class="logo" :class="{ 'logo-mobile': isMobile }" style="margin-inline: auto; margin-top: 30px; margin-bottom: 30px">
                <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
                <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" />
                <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'"
                    style="width: 100%; height: 100%;" />
                <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
                <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
            </div>
            <nav class="navigation">
                <ul>

                </ul>
            </nav>
        </header>
        <div class="container">
            <div class="header" v-id="situacaoDocumento != null && situacaoDocumento.Guid != null">
                <h3 v-if="this.user">Olá, {{ situacaoDocumento.NomeAssinante }}. O documento abaixo está pendente para sua
                    assinatura, veja os termos e condições: </h3>
                <h3 v-if="!this.user">Olá. O documento abaixo está pendente para sua assinatura, veja os termos e
                    condições: </h3>
                <h3>{{ situacaoDocumento.NomeDocumento }}</h3>
                <div class="document-container" :class="{ 'document-container-mobile': isMobile }">
                    <span v-html="conteudoTermosFormatado">
                    </span>
                </div>
                <p>Clicando em 'Confirmar assinatura' você confirma que leu e aceitou os termos do documento.</p>
                <button type="button" :disabled="disableBtnLogin" :class="{ disabledBtn: disableBtnLogin }"
                    @click="assinarDocumento" style="width: 40%;" class="submit-button">
                    <span class="btnText" v-if="!disableBtnLogin">Confirmar assinatura</span>
                    <div class="loadingDots" v-if="disableBtnLogin">
                        <span class="dot">.</span>
                        <span class="dot2">.</span>
                        <span class="dot3">.</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import api from '@/api/axios';
import Cookies from 'js-cookie';
import { mapGetters } from 'vuex';

export default {
    name: 'ConfirmarConta',
    computed: {
        ...mapGetters({
            situacaoDocumento: 'GET_SITUACAO_DOCUMENTO_ASSINATURA',
            user: 'auth/user'
        }),
        conteudoTermosFormatado() {
            return this.conteudoTermos.replace(/<a href/g, '<a target="_blank" href');
        }
    },
    data() {
        return {
            nomeEmpresa: '',
            guidAssinatura: '',
            messageError: null,
            erro: false,
            disableBtnLogin: false,
            conteudoTermos: '',
            requisicaoFinalizada: false,
            isMobile: window.innerWidth <= 768
        };
    },
    mounted() {
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
        this.guidAssinatura = this.$route.params.id;
        this.$store.dispatch('FETCH_CONSULTA_ASSINANTE_DOCUMENTOO', this.guidAssinatura);
        this.disableBtnLogin = false;
        
        // Add resize event listener to update isMobile
        window.addEventListener('resize', this.checkMobile);
    },
    
    beforeUnmount() {
        // Remove event listener when component is unmounted
        window.removeEventListener('resize', this.checkMobile);
    },
    watch: {
        situacaoDocumento() {
            this.requisicaoFinalizada = true;
            console.log(this.situacaoDocumento.Status);
            if (this.situacaoDocumento.Status != 'Pendente') {
                this.$swal({
                    icon: 'error',
                    title: 'Assinatura indisponível',
                    text: 'Documento não está disponível para assinatura.',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push({ name: 'UserLogin' });
                    }
                });

            } else {
                this.conteudoTermos = this.situacaoDocumento.Conteudo;
            }
        }
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        async getIpAddress() {
            try {
                const response = await fetch("https://api.ipify.org?format=json");
                const data = await response.json();
                return data.ip;
            } catch (error) {
                console.error("Error fetching IP address:", error);
                return null;
            }
        },
        async assinarDocumento() {
            var ip = await this.getIpAddress();
            if (!ip) {
                console.error("Error fetching IP address:");
                this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
            }
            this.disableBtnLogin = true;
            if (this.guidAssinatura == '') {
                this.messageError = 'Verifique os dados';
                this.erro = true;
                return;
            }
            var model = { Guid: this.guidAssinatura, Ip: ip }
            await api
                .post('/declaracao/assinar', model)
                .then((retorno) => {
                    this.disableBtnLogin = false;
                    if (!retorno.data) {
                        this.$swal({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Falha na validação da assinatura`,
                        });
                    }
                    else {
                        this.$swal({
                            icon: 'success',
                            title: 'Documento assinado!',
                            text: `O assinatura foi realizada com sucesso!`,
                        });
                        this.$router.replace({
                            path: '/login',
                        });
                    }
                })
                .catch((error) => {
                    this.disableBtnLogin = false;
                    this.disableBtn = false;
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `${error.response.data.descricao}`,
                    });
                });
        },
        logoff() {
            localStorage.removeItem('ClienteId');
            localStorage.removeItem('NomeRazaoSocial');
            localStorage.removeItem('Email');
            localStorage.removeItem('token');
            Cookies.remove('nomeUsuarioLogado');
            this.$router.push({ name: 'UserLogin' });
        },
    }
};

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.document-container {
    max-height: 500px;
    min-height: 250px;
    max-width: 600px;
    padding-right: 25px;
    padding-left: 25px;
    overflow: hidden scroll;
}

.document-container-mobile {
    max-height: 400px;
    min-height: 200px;
    max-width: calc(100% - 40px);
    padding: 15px;
    margin: 0 30px;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.submit-button {
    width: 100%;
    padding: 0.5rem;
    margin-top: 1rem;
    color: white;
    border: none;
    background: #03204f;
    text-align: center;
    border: 1px solid #5E84C3;
    border-radius: 8px;
    cursor: pointer;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
    cursor: pointer;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    ;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 768px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
    
    .container {
        padding: 20px;
        margin: 15px;
        width: calc(100% - 30px);
    }
    
    .header h3 {
        font-size: 18px;
        padding: 0 15px;
        text-align: center;
    }
    
    .header p {
        font-size: 14px;
        padding: 0 15px;
        text-align: center;
    }
    
    .submit-button {
        width: 90% !important;
    }
    
    .site-header {
        padding: 0 1rem;
    }
    
    .logo-mobile {
        margin-top: 15px !important;
        margin-bottom: 15px !important;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}
</style>